import { h } from 'preact'
import Tooltip from '../ui-components/Tooltip'
import Icon from '../assets'
import { Loader } from './Loader'

interface KeyInsightCardProps {
    title: string,
    titleTooltip?: string,
    comparisionTooltip?: string,
    total?: number,
    percent?: number,
    isPercentage?: boolean,
    isLoading: boolean
}

export const KeyInsightCard = ({ title, total, percent, titleTooltip, comparisionTooltip, isPercentage = false, isLoading }: KeyInsightCardProps) => {
  const isNegative = percent && percent < 0
  return (
    <div className='metric-summary-wrapper'>
      <div className='metric-summary'>
        <div className='metric-header'>
          <div className='metric-title'>{title}
            {titleTooltip && <Tooltip
              position='left'
              trigger={<Icon icon='question' width={16} height={16} customClass='icon-info' />}
              customClasses='metric-help-tooltip'
              tooltipMessage={titleTooltip}
            />}
          </div>
        </div>
        {isLoading ? <Loader />
          : <div className='metric-additional-data'>
            <div className='metric-count'>{isPercentage ? `${total?.toFixed()}%` : total}</div>
            {isPercentage ? null
              : <div className='metric-comparision'>
                { percent === 0 ? <div className='metric-percentage metric-text'> - </div>
                  : <div className={`metric-percentage ${isNegative ? 'metric-percentage-negative' : 'metric-percentage-positive'}`}>
                    {!isNegative && '+'}{percent?.toFixed()}%
                  </div>}
                <div className='metric-text'>vs previous period
                  {comparisionTooltip && <Tooltip position='left'
                    trigger={<Icon width={16} height={16} icon={'question'} customClass='icon-previous-period-info' />}
                    customClasses='metric-help-tooltip'
                    tooltipMessage={comparisionTooltip} />}
                </div>
              </div>}
          </div>}
      </div>
    </div>)
}
